import {useAccountInformationValue} from '@/auth/hooks/useAccountInformation'
import {useLocale} from '@/lib/locale/locale'
import {type BookmarkedProduct, hashProduct} from '@/models/productModel'
import queries from '@/queries/queries'
import {getBookmarts} from '@/services/bookmarkService'

export default memo(function BookmarkUpdater() {
  const [locale] = useLocale()
  const accountInformation = useAccountInformationValue()

  useQuery(
    queries.getQueryOptions({
      name: 'bookmark',
      params: [locale, accountInformation],
      queryFn: async ({signal}) => {
        const bookmarks = await getBookmarts({locale, signal})
        const bookmarkMap = new Map<string, BookmarkedProduct>()
        bookmarks.forEach(bookmark => {
          bookmarkMap.set(hashProduct(bookmark), bookmark)
        })
        return bookmarkMap
      },
      refetchInterval: 100000, // every 100s
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }),
  )

  return null
})
